/* eslint-disable import/no-anonymous-default-export */
import {
    TO_NUMBER
} from '../actions/types'

export default (state = {to: null}, action) => {
    switch (action.type) {
        case TO_NUMBER:
            return action.payload;
        default:
            return state;
    }
}